(() => {
  if (customElements.get('dod-cart-upgrade')) return;
  if (!customElements.get('dod-cart-pack')) customElements.define('dod-cart-pack', class extends HTMLElement {
    connectedCallback() {
      this.observer = new ResizeObserver(() => this.fit());
      this.observer.observe(this);
      this.fit();
    }
    disconnectedCallback() { this.observer?.disconnect(); }
    fit() {
      const pack = this.querySelector('[data-bounds]');
      if (!pack || !this.clientWidth || !this.clientHeight) return;
      const image = pack.querySelector('img');
      const [left, top, right, bottom, width, height] = pack.dataset.bounds.split(',').map(Number);
      const scale = Math.min(this.clientWidth * .94 / (right - left), this.clientHeight * .94 / (bottom - top));
      Object.assign(image.style, {width:width * scale + 'px', height:height * scale + 'px', left:(this.clientWidth - (right - left) * scale) / 2 - left * scale + 'px', top:(this.clientHeight - (bottom - top) * scale) / 2 - top * scale + 'px'});
    }
  });
  let adding = false;
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  class CartUpgrade extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-upgrade-copy]').textContent);
      this.cards = [...this.querySelectorAll('[data-upgrade-game]')];
      this.status = this.querySelector('[data-upgrade-status]');
      this.events = new AbortController();
      const signal = this.events.signal;
      this.choices = this.querySelector('[data-upgrade-choices]');
      if (this.choices) {
        const buttons = this.cards.map(card => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'dod-upgrade__choice';
          button.dataset.upgradeSelect = card.dataset.upgradeGame;
          button.setAttribute('aria-pressed', String(!card.hidden));
          const image = document.createElement('span');
          image.className = 'dod-upgrade__choice-image';
          image.setAttribute('aria-hidden', 'true');
          const pack = card.querySelector('dod-cart-pack');
          if (pack) image.append(pack.cloneNode(true));
          const title = document.createElement('span');
          title.className = 'dod-upgrade__choice-title';
          title.textContent = card.dataset.upgradeTitle;
          const check = document.createElement('span');
          check.className = 'dod-upgrade__choice-check';
          check.setAttribute('aria-hidden', 'true');
          check.textContent = '✓';
          button.append(image, title, check);
          return button;
        });
        this.choices.replaceChildren(...buttons);
        this.choices.addEventListener('scroll', () => this.updateNavigation(), {passive:true, signal});
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.choices);
        this.updateNavigation();
      }
      this.addEventListener('click', event => {
        const select = event.target.closest('[data-upgrade-select]');
        if (select && !adding) {
          this.cards.forEach(card => { card.hidden = card.dataset.upgradeGame !== select.dataset.upgradeSelect; });
          this.choices.querySelectorAll('[data-upgrade-select]').forEach(button => button.setAttribute('aria-pressed', String(button === select)));
          this.status.textContent = '';
        }
        const navigation = event.target.closest('[data-upgrade-scroll]');
        if (navigation && this.choices && !adding) {
          const direction = Number(navigation.dataset.upgradeScroll);
          this.choices.scrollBy({left:direction * this.choices.clientWidth * .8, behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }
        const button = event.target.closest('[data-upgrade-add]');
        if (button) this.add(button);
      }, {signal});
    }
    disconnectedCallback() {
      this.events?.abort();
      this.resizeObserver?.disconnect();
      this.ready = false;
    }
    updateNavigation() {
      if (!this.choices) return;
      const maximum = this.choices.scrollWidth - this.choices.clientWidth;
      const position = this.choices.scrollLeft;
      this.querySelector('[data-upgrade-scroll="-1"]').disabled = position <= 2;
      this.querySelector('[data-upgrade-scroll="1"]').disabled = position >= maximum - 2;
    }
    async request(path, data) {
      const response = await fetch(this.dataset.root + path, data ? {
        method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(data)
      } : {headers:{Accept:'application/json'}});
      const result = await response.json();
      if (!response.ok || result.status || result.errors) throw new Error(typeof result.description === 'string' ? result.description : this.copy.error);
      return result;
    }
    async render(drawer, cart) {
      if (sections.some(key => !cart.sections?.[key])) cart = await this.request('cart/update.js', {sections, sections_url:location.pathname});
      if (sections.some(key => !cart.sections?.[key])) {
        location.assign(this.dataset.root + 'cart');
        return false;
      }
      drawer.classList.toggle('is-empty', cart.item_count === 0);
      drawer.renderContents(cart, false);
      return true;
    }
    async add(button) {
      if (adding) return;
      if (window.DODGameTiers?.busy) { this.status.textContent = this.copy.upgrade_busy; return; }
      const drawer = this.closest('cart-drawer');
      const productId = button.closest('[data-upgrade-game]').dataset.upgradeGame;
      const variantId = Number(button.dataset.upgradeAdd);
      const controls = [...drawer.querySelectorAll('button, input, select')].filter(control => !control.disabled && !control.classList.contains('drawer__close'));
      const label = button.textContent;
      const scrollTop = drawer.querySelector('cart-drawer-items').scrollTop;
      adding = true;
      const release = window.DODGameTiers?.begin();
      controls.forEach(control => { control.disabled = true; });
      this.status.textContent = '';
      button.textContent = this.copy.adding;
      this.setAttribute('aria-busy', 'true');
      let added = false;
      let cart;
      let message = '';
      try {
        cart = await this.request('cart.js');
        if (cart.items.some(item => String(item.product_id) === productId)) {
          message = this.copy.upgrade_already;
        } else {
          cart = await this.request('cart/add.js', {items:[{id:variantId, quantity:1}], sections, sections_url:location.pathname});
          added = true;
          message = this.copy.upgrade_added;
        }
        if (window.DODGameTiers) cart = await window.DODGameTiers.sync(cart, sections);
        if (!await this.render(drawer, cart)) return;
      } catch (error) {
        if (!added) { this.status.textContent = error.message || this.copy.error; return; }
        try {
          cart = await this.request('cart/update.js', {sections, sections_url:location.pathname});
          if (!await this.render(drawer, cart)) return;
          message = this.copy.upgrade_partial;
        } catch (_) { location.assign(this.dataset.root + 'cart'); return; }
      } finally {
        adding = false;
        release?.();
        controls.forEach(control => { if (control.isConnected) control.disabled = false; });
        if (button.isConnected) button.textContent = label;
        this.removeAttribute('aria-busy');
      }
      const status = drawer.querySelector('[data-upgrade-status]') || drawer.querySelector('#CartDrawer-CartErrors');
      if (status) status.textContent = message;
      drawer.querySelector('cart-drawer-items').scrollTop = scrollTop;
      drawer.querySelector('#CartDrawer-Checkout')?.focus({preventScroll:true});
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, {source:'cart-items', productVariantId:variantId, cartData:cart});
    }
  }
  customElements.define('dod-cart-upgrade', CartUpgrade);
})();

(() => {
  if (customElements.get('dod-cart-empty-gifts')) return;
  let chosenGift = '';
  try { chosenGift = sessionStorage.getItem('dod-ln-pending-gift') || ''; } catch (_) {}
  document.addEventListener('dod:gift-state', event => {
    chosenGift = String(event.detail.selected || '');
    document.querySelectorAll('dod-cart-empty-gifts').forEach(element => element.update());
  });
  class EmptyCartGifts extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.copy = JSON.parse(this.querySelector('[data-empty-gift-copy]').textContent);
      this.buttons = [...this.querySelectorAll('[data-empty-gift-pick]')];
      this.status = this.querySelector('[data-empty-gift-status]');
      this.events = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-empty-gift-pick]');
        if (button && this.contains(button)) this.choose(button);
      }, {signal:this.events.signal});
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
    }
    update() {
      if (!this.buttons) return;
      const host = document.querySelector('dod-welcome-gift');
      const ready = host?.dataset.checkoutReady === 'true' && host.dataset.designMode !== 'true' && Boolean(window.DODGameTiers);
      this.buttons.forEach(button => {
        const selected = button.dataset.emptyGiftPick === chosenGift;
        button.disabled = !ready || Boolean(this.busy);
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-label', selected ? button.dataset.selectedLabel : button.dataset.giftLabel);
        button.textContent = this.busy && this.pendingGift === button.dataset.emptyGiftPick ? this.copy.updating : selected ? this.copy.selected : this.copy.choose;
        button.closest('[data-empty-gift-card]').classList.toggle('is-selected', selected);
      });
      this.setAttribute('aria-busy', String(Boolean(this.busy)));
      if (!this.busy && !this.error) this.status.textContent = this.buttons.some(button => button.dataset.emptyGiftPick === chosenGift) ? this.copy.reserved : '';
    }
    async choose(button) {
      if (this.busy || button.disabled || button.dataset.emptyGiftPick === chosenGift) return;
      if (window.DODGameTiers?.busy) { this.status.textContent = this.copy.updating; return; }
      this.busy = true;
      this.error = false;
      this.pendingGift = button.dataset.emptyGiftPick;
      this.status.textContent = '';
      this.update();
      try {
        const cart = await window.DODGameTiers.selectGift(this.pendingGift);
        if (cart.gift_notice) throw new Error(cart.gift_notice);
        try { sessionStorage.setItem('dod-ln-gift-seen', '1'); } catch (_) {}
        if (cart.item_count) window.DODGameTiers.render(cart);
      } catch (error) {
        this.error = true;
        this.status.textContent = error.message || this.copy.unavailable;
      } finally {
        this.busy = false;
        this.pendingGift = '';
        this.update();
      }
    }
  }
  customElements.define('dod-cart-empty-gifts', EmptyCartGifts);
})();

